var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPowerOff = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2743L0.731429 0L0 0.725714L2.93714 3.66286C2.85143 3.81714 2.79429 3.98286 2.79429 4.15429V7.29714L4.79429 9.29714V11.0114H7.65143V9.29714L8.11429 8.84L11.2743 12L12 11.2743ZM6.84572 8.49143L6.60571 8.72571H5.84L5.60571 8.49143L3.93714 6.82286V4.66286L7.30286 8.02857L6.84572 8.49143ZM6.33714 4.15429L5.19429 3.01143H7.36572V0.725714H8.50857V3.01143C9.08 3.01143 9.65143 3.58286 9.65143 4.15429V7.29714L9.56571 7.38286L8.50857 6.32571V4.20571C8.50857 4.18857 8.48 4.15429 8.46286 4.15429H6.33714ZM5.08 2.89714L3.93714 1.75429V0.725714H5.08V2.89714Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPowerOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/power-off.87b5aff6.svg";
export { ForwardRef as ReactComponent };